// Phone card fan geometry shared by the canvas and its bounds test.
export const MOBILE_HERO = Object.freeze({ w: 360, h: 210 });
export const MOBILE_CARD = Object.freeze({ w: 92, h: 129 });
export const MOBILE_FLOAT = Object.freeze({ wrapperPadding: 14, travel: 6, durationMs: 6000 });
export const MOBILE_CARDS = Object.freeze([
  { cardId: 'AH', dx: -78, dy: 14, rot: -0.18 },
  { cardId: 'KD', dx: 78, dy: 14, rot: 0.18 },
  { cardId: 'JS', dx: 0, dy: 0, rot: 0 },
]);

export function mobileCardBounds(card) {
  const halfW = (Math.abs(Math.cos(card.rot)) * MOBILE_CARD.w + Math.abs(Math.sin(card.rot)) * MOBILE_CARD.h) / 2;
  const halfH = (Math.abs(Math.sin(card.rot)) * MOBILE_CARD.w + Math.abs(Math.cos(card.rot)) * MOBILE_CARD.h) / 2;
  const x = MOBILE_HERO.w / 2 + card.dx;
  const y = MOBILE_HERO.h * 0.48 + card.dy;
  return { left: x - halfW, right: x + halfW, top: y - halfH, bottom: y + halfH };
}
